

























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { EventTypesApi, NotificationsApi, ProductsApi } from '../../api';

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import { ParsingUtil } from '@/common/ParsingUtil';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
	components: {},
	props: {
		productId: Number,
		productType: String,
		entityType: String | null,
		entityId: Number | null,
	},
})
export default class Eve extends Vue {
	public productId: number | undefined;
	public entityId: number | undefined;
	public entityType: number | undefined;

	public dateForm = {
		start: moment()
			.subtract(30, 'days')
			.locale('en-nz')
			.format('X')
			.toString(),
		end: moment()
			.locale('en-nz')
			.format('X')
			.toString(),
	};

	public eventSubscriptions = [];

	public eventSubscriptionsFields = [
		{ key: 'createdAt', label: 'Created' },
		{ key: 'updatedAt', label: 'Updated' },
		{ key: 'eventType', label: 'Event Type' },
		{ key: 'userName', label: 'User Name' },
		{ key: 'channel', label: 'Channel' },
		{ key: 'audits', label: 'Changes' },
	];
	public eventSubscriptionAuditFields = [
		{ key: 'created_at', label: 'Created' },
		{ key: 'event', label: 'Event Type' },
		{ key: 'old_values', label: 'From' },
		{ key: 'new_values', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];
	public selected = null;

	public loading = false;

	public created() {
		this.eventSubscriptionAuditData();
	}

	public async eventSubscriptionAuditData() {
		const productId: number | null = ParsingUtil.parseId(this.$route.params.productId);
		if (productId == null) {
			this.loading = false;
			return;
		}
		try {
			const data = await new ProductsApi().getProductById(parseInt(this.productId, 10), {
				params: {
					include: 'eventsubscriptions.audits.user,users',
				},
			});
			const types = await new EventTypesApi().getEventTypesByProductType(this.productType);
			this.eventSubscriptions = data.data.eventsubscriptions;
			if (this.entityType && this.entityId) {
				this.eventSubscriptions = this.eventSubscriptions.filter(
					eventsubscription =>
						eventsubscription.entityType === this.entityType &&
						eventsubscription.entityId == this.entityId,
				);
			}
			this.eventSubscriptions = this.eventSubscriptions.map(es => {
				return {
					...es,
					eventType: types.data.data.find(et => et.id === es.eventTypeId).title,
					userName: data.data.users.find(user => user.id === es.userId).name,
				};
			});
		} catch (e) {
			console.log(e);
		} finally {
			this.loading = false;
		}
	}
}
